import { useState, useCallback } from 'react';

export const useToggle = <T>(first: T, second: T) => {
  const [value, setValue] = useState(first);

  const toggle = useCallback(
    () => setValue((v) => (v === first ? second : first)),
    [first, second],
  );

  const reset = useCallback(() => setValue(first), [first]);

  return [value, toggle, reset] as const;
};
